<template>
  <div>
    <div
      v-if="!isMobile || (isMobile && !showGoToCart)"
      class="row"
    >
      <div
        v-if="!showAddedToCart"
        class="col-xs-4 visible-xs-block"
      >
        <div class="add-to-cart__button-price">
          {{ subTotalFormatted }}
        </div>
      </div>
      <div :class="buttonWrapperClasses">
        <button
          v-if="showAddToCart || showAddingToCart"
          type="submit"
          class="button button--fw button--cta button--center-text add-to-cart__button-cta"
          @click="handleAddToCartClick($event)"
        >
          Add to Cart&nbsp;
          <span
            v-if="showAddingToCart"
            class="fa fa-spinner fa-spin fa-2 adding-to-cart-icon"
          />
        </button>
        <button
          v-if="showAddedToCart"
          type="button"
          class="button button--fw button--cta button--added-to-cart"
        >
          <span class="button-text--icon-adjacent">Added</span>
          <span class="fa fa-check-circle fa-3 button-icon"/>
          <span class="button-text--icon-adjacent">to Cart!</span>
        </button>
        <button
          v-if="showGoToCart"
          type="button"
          class="button button--fw button--cta button--center-text"
          @click="handleGoToCartClick"
        >Go to Cart
          <div class="button-image-icon-wrapper">
            <span class="cart-item-count-bubble">{{ numItemsInCart }}</span>
            <img :src="cartIcon" >
          </div>
        </button>
      </div>
    </div>
    <div
      v-if="showGoToCart"
      class="row row--after-added"
    >
      <div class="col-xs-6 col--after-added">
        <button
          type="button"
          class="button button--fw button--outline button--after-card-add"
          @click="handleCatalogListButtonClick"
        >Keep Shopping</button>
      </div>
      <div class="col-xs-6 col--after-added hidden-xs">
        <button
          type="button"
          class="button button--fw button--outline button--after-card-add"
          @click="handleShopPackageAgainButtonClick"
        >Customize Again</button>
      </div>
      <div class="col-xs-6 col--after-added visible-xs">
        <button
          type="button"
          class="button button--fw button--cta"
          @click="handleGoToCartClick"
        >Go to Cart
          <div
            class="button__image button__image--empty button__image--no-hover button__image--icon button__image--go-to-cart"
          >
            <div class="button-image-icon-wrapper">
              <span class="cart-item-count-bubble">{{ numItemsInCart }}</span>
              <img :src="cartIcon" >
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// TODO - Need to update this component to do currency formatting client-side for the subTotal property. Currently used a hard-wired $

import cartIcon from '@Shared/svg/cart--white.svg'
import currencyFormatter from '@/shared/lib/currency-formatter'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import ToastMixin from '@Shared/mixins/toast'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'
import _ from 'lodash'

export default {
  name: 'AddToCartButton',
  mixins: [
    ToastMixin,
    ResponsiveBreakpointsMixin
  ],
  props: {
    subTotal: { type: Number, default: null },
    showRetouchingModalOnClick: { type: Boolean, default: false },
    frameId: { type: [String, Number], default: null },
    packageRetailName: { type: String, default: null }
  },
  data () {
    return {
      showAddToCart: true,
      showAddingToCart: false,
      showAddedToCart: false,
      showGoToCart: false,
      cartUrl: null,
      numItemsInCart: null,
      cartIcon
    }
  },
  computed: {
    buttonWrapperClasses () {
      return {
        'col-xs-8': !this.showAddedToCart,
        'col-sm-12': true
      }
    },
    subTotalFormatted () {
      if (this.subTotal === null) {
        return null
      }

      return currencyFormatter.format(this.subTotal, this.currentCultureNumberFormat, this.currency)
    },
    currentCultureNumberFormat () {
      return this.$store.state.catalogPageCommon.currentCultureNumberFormat
    },
    currency () {
      return this.$store.state.catalogPageCommon.currency
    }
  },
  watch: {
    showAddedToCart (v, ov) {
      if (v === true) {
        setTimeout(() => {
          this.showAddedToCart = false
          this.showGoToCart = true
        }, 3000)
      }
    },
    numItemsInCart: (v, ov) => {
      document.dispatchEvent(
        new CustomEvent('cart.numItemsChanged', { detail: { numItems: v } })
      )
    }
  },
  created () {
    document.addEventListener('package.isInvalid', e => {
      this.showAddToCart = true
      this.showAddingToCart = false
      this.addToCartInProgress = false
    })

    document.addEventListener('package.addedToCartSuccess', e => {
      this.showAddingToCart = false
      this.showAddedToCart = true
      this.addToCartInProgress = false

      this.cartUrl = e.detail.CartUrl
      this.numItemsInCart = e.detail.NumberPackagesInCart
    })

    document.addEventListener('package.addedToCartFail', e => {
      this.showAddToCart = true
      this.showAddingToCart = false
      this.showAddedToCart = false
      this.addToCartInProgress = false

      if (e.detail && e.detail.errors !== undefined && e.detail.errors.length > 0) {
        _.each(e.detail.errors, (error) => {
          this.makeToast('error', 'Error Adding Item to Cart', error)
        })
      } else {
        this.makeToast('error', 'Error Adding Item to Cart', 'There was an error adding an item to your cart.')
      }
    })

    document.addEventListener('package.addToCartFormSubmitted', e => {
      this.showAddToCart = false
      this.showAddingToCart = true
      this.addToCartInProgress = false
    })
  },
  methods: {
    handleAddToCartClick (event) {
      if (this.addToCartInProgress === true) {
        // don't submit again if already submitted/adding to cart
        event.preventDefault()
        return false
      }

      GoogleAnalytics.trackEvent('Add to Cart', 'click', this.packageRetailName)

      this.addToCartInProgress = true

      if (this.showRetouchingModalOnClick === true) {
        event.preventDefault()

        document.dispatchEvent(
          new CustomEvent('retouchingModal.show', {
            detail: { frameId: this.frameId, addToCartMode: true }
          })
        )

        this.addToCartInProgress = false

        return false
      }

      this.showAddToCart = false
      this.showAddingToCart = true
    },
    handleGoToCartClick () {
      GoogleAnalytics.trackEvent('Add to Cart', 'click', 'Go to Cart')
      window.location.href = this.cartUrl
    },
    handleCatalogListButtonClick () {
      GoogleAnalytics.trackEvent('Add to Cart', 'click', 'Keep Shopping')
      window.location.href = this.$store.state.catalogPageCommon.catalogListUrl
    },
    handleShopPackageAgainButtonClick () {
      GoogleAnalytics.trackEvent('Add to Cart', 'click', 'Customize Again')
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart {
  &__button-price {
    background-color: #efeeee;
    color: #494949;
    font-weight: bold;
    font-size: 22px;
    padding-top: 8px;
  }

  &__button-cta {
    font-size: 16px !important;
  }
}

.button {
  font-size: 12px;
  text-align: center;

  &--added-to-cart {
    background-color: #8bcc6f;
    color: #fff;
    text-align: center;
    margin: 0;
    padding: 5px 0 0 0;
  }

  &--outline {
    background-color: #fff;
    color: $grad-color-blue;
    border: 2px solid $grad-color-blue;
    text-align: center;
    line-height: 1em;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      outline: 4px solid $grad-color-blue;
      outline-offset: -2px;
    }
  }

  &--center-text {
    padding-right: 21px;
  }

  &-icon {
    font-size: 40px;
    margin: 0 6px;
  }

  &-text {
    &--icon-adjacent {
      position: relative;
      top: -7px;
    }
  }

  &-image {
    &-icon-wrapper {
      position: relative;
      display: inline-block;
    }
  }

  &__image {
    &--go-to-cart {
      right: 14px;
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    font-size: 16px;

    &__image {
      &--go-to-cart {
        right: 20px;
      }
    }

    &--after-card-add {
      font-size: 13px;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &--after-card-add {
      font-size: 16px;
    }
  }
}

.col--after-added {
  padding: 6px;
}

.cart-item-count-bubble {
  position: absolute;
  background: #8bcc6f;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 8px;
  color: #fff;
  font-weight: 800;
  top: 0;
  right: -10px;
  width: 16px;
  height: 16px;
  line-height: 12px;

  @media screen and (min-width: $screen-sm-min) {
    right: -14px;
  }
}

.add-to-cart__wrapper .button__image {
  display: block; // overrides default styling that hides this on mobile
}

.adding-to-cart-icon {
  display: inline-block;
  position: relative;
  top: 4px;
}

.row--after-added {
  background-color: #999;
  padding: 0 10px;

  @media screen and (min-width: $screen-sm-min) {
    background-color: transparent;
    margin-top: 20px;
  }
}

@media screen and (min-width: $screen-sm-min) {
  .button-image-icon-wrapper {
    top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/AddToCartButton.vue